<div class="input-group input-group-sm">
    <spv2-boolean-dropdown [(value)]="value" (valueChange)="valueChange.emit($event)" (userChangedValue)="startDebounce();" [smallView]="smallView"></spv2-boolean-dropdown>
</div>